import { render, staticRenderFns } from "./ListTPAs.vue?vue&type=template&id=c8b98542&scoped=true&"
import script from "./ListTPAs.vue?vue&type=script&lang=js&"
export * from "./ListTPAs.vue?vue&type=script&lang=js&"
import style0 from "./ListTPAs.vue?vue&type=style&index=0&id=c8b98542&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b98542",
  null
  
)

export default component.exports